export default __webpack_public_path__ + "static/felicity-joslin-1-552944dbe86ed71bf417e8146e716507.webp";